import { createFormState } from "redux-freeform";
import { required } from "redux-freeform";
import { ReduxFreeformField } from "../../types";

export type TerminalsFormConfig = {
  [key: string]: ReduxFreeformField;
};

export const terminalsFormConfig: TerminalsFormConfig = {
  location_id: {
    defaultValue: "",
    validators: [required()],
  },
  name: {
    defaultValue: "",
    validators: [required()],
  },
  payment_source: {
    defaultValue: "",
    validators: [required()],
  },
  kiosk_id: {
    defaultValue: "",
    validators: [required()],
  },
  credit_card_reader_type_id: {
    defaultValue: "",
    validators: [],
  },
  internal_device_id: {
    defaultValue: "",
    validators: [],
  },
  read_only: {
    defaultValue: "",
    validators: [],
  },
};

export const {
  reducer: terminalsFormReducer,
  mapStateToProps: terminalsFormMapStateToProps,
  mapDispatchToProps: terminalsFormMapDispatchToProps,
} = createFormState(terminalsFormConfig);
